<template>
  <div class="reset">
    <Header/>
    
    <div class="breadcrumb-area gray-bg">
            <div class="container">
                <div class="breadcrumb-content">
                    <ul>
                        <li><router-link to="/">Home</router-link></li>
                        <li class="active"> Password Reset </li>
                    </ul>
                </div>
            </div>
		</div>

    <div class="about-us-area pt-25 pb-25">
			<div class="container">
				<div class="container my-4" v-if="pageLoader">
					<i class="fa fa-spinner fa-spin product-loader center"></i>
				</div>

				<template v-if="verifiedToken">
					<h3 class="page-title">Reseting password for <i> {{email}} </i></h3>

					<div v-if="successResponse" class="alert alert-success rounded" role="alert">
							<i class="fa fa-checkmark fa-lg  px-2"></i>			
							Password changed successfully! Go to <router-link to="/login">Login</router-link>
					</div>

					<div v-if="errorResponse" class="alert alert-danger rounded" role="alert">
						<i class="fa fa-times fa-lg px-2"></i> {{errorMsg}}									
					</div>	

					<div class="grand-totall bg-white">
							<div class="row">
								<div class="col-lg-6 col-12 form-group">
									<label>New Password</label>
									<input class="form-control input-sm rounded" ref="password" type="password"/>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-6 col-12 form-group">
									<label>Confirm Password</label>
									<input class="form-control input-sm rounded" ref="password_confirmation" type="password"/>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-6 col-12 form-group">
									<a class="golden-btn mt-4 rounded" @click="submitPassword()">
										<span class="btn_text text-white" v-show="!loader">Reset Password</span>
										<i class="fa fa-spinner fa-spin mt-2 text-white" v-show="loader"></i>
									</a>
								</div>
							</div>
					</div>
				</template>	

				<template v-else>
					<div v-if="msg != null" class="alert alert-danger m-0" role="alert">
							<i class="fa fa-times fa-lg  px-2"></i>			
							{{msg}} Go back to <router-link to="/login">Login</router-link>
					</div>
				</template>
 			</div>
		</div>

    <Footer/>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import User from "../apis/user"

export default {
  name: 'PasswordReset',
  components: {
    Header,
    Footer
  },

	data: function () {
      return {
				token: null,
				email: null,
        loader: false,
				pageLoader: false,
				verifiedToken: false,
				msg: null,

				errorResponse: false,
				errorMsg: null,
				successResponse: false
      };
    },
	created: function () {
    this.verifyToken();
  },

	methods: {
		verifyToken() {
			var that = this;
			this.token = this.$route.query.auth_token
			this.email = this.$route.query.email
			
			this.pageLoader = true;
			var data = {};

			data.token = this.token
			data.email = this.email

			User.verify(data)
				.then((response) => {
					that.pageLoader = false; 

					if(response.data == "success") {
						that.verifiedToken = true
					}  
					else {
						that.msg = response.data
					}           
				})
				.catch(function (err) {
					that.pageLoader = false; 					
					that.msg = err.response.data.message
				});
		},

		submitPassword() {
			var that = this;
			this.loader = true;
			var data = {};

			data.token = this.token
			data.password = this.$refs.password.value
			data.password_confirmation = this.$refs.password_confirmation.value

			User.reset(data)
				.then((response) => {
					that.loader = false;

					if(response.data == "success") {
						that.successResponse = true;
						that.errorResponse = false;
					}  
					else {
						that.errorResponse = true;
						that.errorMsg = response.data

						that.successResponse = false;
					} 
				})
				.catch(function (err) {
					that.loader = false;    

					that.errorResponse = true;
					that.errorMsg = err.response.data.message

					that.successResponse = false;	
				});
		}
	}
}
</script>
